import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// vendored from packages/editor/editor-plugin-ai/src/experience-application/screens-with-logic/LoadingScreenWithLogic.tsx
// similar logic also exists in packages/editor/renderer/src/ui/Renderer/index.tsx
import React, { Fragment, Suspense, useEffect, useMemo, useRef, useState } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { encodeAdf } from '@atlassian/conversation-assistant-content-renderer';
import { StatusCitation } from '../ai-answer-body/ai-answer-result/rendered/status-citation';
import { AIAnswerLoadingStreamMarkdownContainer, AIAnswerResultBlurSection } from './styled';
var ReactRenderer = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_.renderer" */'@atlaskit/renderer').then(function (_ref) {
    var ReactRenderer = _ref.ReactRenderer;
    return {
      default: ReactRenderer
    };
  });
});
var MarkdownRenderer = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "react-markdown" */'react-markdown').then(function (_ref2) {
    var ReactMarkdown = _ref2.default;
    return {
      default: ReactMarkdown
    };
  });
});
var isScrolledToEnd = function isScrolledToEnd(element) {
  return !!element && Math.abs(element.scrollHeight - element.clientHeight - element.scrollTop) < 10;
};
export var AIAnswerLoadingStream = function AIAnswerLoadingStream(_ref3) {
  var markdown = _ref3.markdown;
  var containerRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showResultBlur = _useState2[0],
    setShowResultBlur = _useState2[1];
  useEffect(function () {
    var renderer = containerRef.current;
    var mutateTelepointer = function mutateTelepointer(mutations) {
      mutations.forEach(function () {
        if (containerRef && !showResultBlur && !isScrolledToEnd(containerRef.current)) {
          setShowResultBlur(true);
        }
      });
    };
    var observer = new MutationObserver(mutateTelepointer);
    observer.observe(renderer, {
      characterData: true,
      attributes: false,
      childList: true,
      subtree: true
    });
    return function () {
      return observer.disconnect();
    };
  });
  var docContent = useMemo(function () {
    return encodeAdf(markdown, false);
  }, [markdown]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AIAnswerLoadingStreamMarkdownContainer, {
    ref: containerRef
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Fragment, null)
  }, fg('kd_smart_answers_use_adf_encoder') ? /*#__PURE__*/React.createElement(ReactRenderer, {
    document: docContent,
    nodeComponents: {
      status: function status(props) {
        return /*#__PURE__*/React.createElement(StatusCitation, props);
      },
      // Preventing media and mediaSingle from rendering images due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
      // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
      media: function media() {
        return /*#__PURE__*/React.createElement(Fragment, null);
      },
      mediaSingle: function mediaSingle() {
        return /*#__PURE__*/React.createElement(Fragment, null);
      }
    }
  }) :
  /*#__PURE__*/
  // Preventing img elements from rendering due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
  // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
  React.createElement(MarkdownRenderer, {
    disallowedElements: ['img']
  }, markdown))), showResultBlur && /*#__PURE__*/React.createElement(AIAnswerResultBlurSection, null));
};